<svelte:options customElement={{
  tag: 'bread-crumb',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' },
    class: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * パンくずリスト
   * @prop {string} items - JSON形式 '[{"href":"/","label":"HOME"},{"href":"/about","label":"会社概要"},{"label":"現在ページ"}]'
   */
  export let items = '[]';
  $: extraClass = $$props['class'] || '';
  $: navClass = ['mod-topicPath', extraClass].filter(Boolean).join(' ');

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('Breadcrumb: Invalid items JSON', e);
      parsedItems = [];
    }
  }
</script>

<nav class={navClass} aria-label="パンくずリスト">
  <div class="mod-topicPath-wrap">
    <div class="mod-topicPath-inner">
      <ul class="mod-topicPath-ul" itemscope itemtype="http://schema.org/BreadcrumbList">
        {#each parsedItems as item, i}
          <li class="mod-topicPath-li" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
            {#if item.href}
              <a class="mod-topicPath-a" itemprop="item" href={item.href}>
                <span class="mod-topicPath-span" itemprop="name">{item.label}</span>
              </a>
              <svg aria-hidden="true">
                <use href="/common/svg/sprite.svg#arrow_right"></use>
              </svg>
            {:else}
              <span class="mod-topicPath-span" itemprop="name">{item.label}</span>
            {/if}
            <meta itemprop="position" content="{i + 1}">
          </li>
        {/each}
      </ul>
    </div>
  </div>
</nav>
